import { NestedSearch, SearchTab } from "@habity/types";
import { getQueryFromFilters } from "./queryFrom";
import { getTabNameFromUrlPath } from "./getTab";

export const getSearchPath = ({
  filters,
  showMap = false,
  tab,
  searchId,
  addressId,
  scrollToId,
}: {
  filters: Partial<NestedSearch> | null;
  showMap?: boolean;
  tab: SearchTab;
  searchId?: string;
  addressId?: string;
  scrollToId?: string;
}) => {
  const searchParams = new URLSearchParams();

  // Set searchId
  if (searchId) {
    searchParams.set("searchId", searchId);
  }
  // Set addressId
  if (addressId) {
    searchParams.set("addressId", addressId);
  }
  // Set map - always preserve the showMap parameter
  if (showMap) {
    searchParams.set("map", "true");
  }
  // Set filters
  const filterParams = getQueryFromFilters(filters);
  const combinedParams = new URLSearchParams([
    ...searchParams,
    ...filterParams,
  ]);
  
  const searchPath = `/${tab}?${combinedParams.toString()}${scrollToId ? `#${scrollToId}` : ""}`;
  return searchPath;
};


export const getSearchParams = (
  filters: Partial<NestedSearch> | null,
  addressId?: string,
) => {
  const searchParams = new URLSearchParams();

  // Set addressId
  if (addressId) {
    searchParams.set("addressId", addressId);
  }

  // Set filters
  const filterParams = getQueryFromFilters(filters);
  const combinedParams = new URLSearchParams([
    ...searchParams,
    ...filterParams,
  ]);

  return combinedParams;
};
